import Vue from 'vue'
import Guid from '@/components/Guid'

export default {
  install() {
    Vue.prototype.$guid = Guid
  }
}
